import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'presto-floating-pill-skin',
  styleUrl: 'presto-floating-pill-skin.scss',
  shadow: false,
})
export class PrestoFloatingPillSkin {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
